import React from "react";
import { connect } from "react-redux";
import { Tag, Popover, Layout, Menu, Row, Col, Segmented } from "antd";
// import "./Patient.scss";
import utils from "../../utils";
import Prescription from "Pages/Others/Prescription";
import TherapyTab from "Pages/Others/TherapyTab";
import DSMScreening from "Pages/Others/DSMScreening";
import MHE from "Pages/Others/MHE";
import DiagnosisNewSummary from "Pages/Others/DiagnosisNewSummary";
import DiagnosisSummary from "Pages/Others/DiagnosisSummary";
import TreatmentSummary from "Pages/Others/TreatmentSummary";
import SOSSummary from "Pages/Others/SOSSummary";
import UploadDocSummary from "Pages/Others/UploadDocSummary";
import ProtectiveFactorSummary from "Pages/Others/ProtectiveFactorSummary";
import DOTSNewSummary from "Pages/Others/DOTSNewSummary";
import GeriatricSummary from "Pages/Others/GeriatricSummary";
import ConcogSummary from "Pages/Others/ConcogSummary";
import { CONSTANTS } from "utils/constant";
import PSTSummary from "Pages/Others/PSTSummary";
import TheraphyProgressNote from "Pages/Others/TheraphyProgressNote";
import { Link } from "react-router-dom";
import configureStore from "store/index";
import VitalFormHistoryDoctor from "Pages/VitalForm/VitalFormHistoryDoctor";
import Sider from "antd/es/layout/Sider";
import { Content, Header } from "antd/es/layout/layout";
import scrollIntoView from "scroll-into-view-if-needed";
import Casesheet from "Pages/Others/Casesheet";
import PatientDetailsAll from "Pages/Others/PatientDetailsAll";
const { store } = configureStore();
const ButtonListsinitial = [
  {
    key: "all",
    label: "All",
  },
  {
    key: "vital",
    label: "Vitals",
  },
  {
    key: "cs",
    label: "Case Sheets",
  },
  {
    key: "diagnosis",
    label: "Diagnosis",
  },
  {
    key: "prescription",
    label: "Prescription",
  },
  {
    key: "cf1",
    label: "Case Sheets",
  },
  {
    key: "cf2",
    label: "Follow Up",
  },
  {
    key: "pst",
    label: "PST",
  },
  {
    key: "protective_factor",
    label: "Protective Factor",
  },
  {
    key: "dots",
    label: "DOTS",
  },
  {
    key: "sos",
    label: "SOS",
  },
  {
    key: "confas",
    label: "CONFAS",
  },
  {
    key: "conpsyq",
    label: "CONPSYQ",
  },
  {
    key: "concog",
    label: "Concog",
  },
  {
    key: "tpn",
    label: "Theraphy Progress Note",
  },
  {
    key: "casesheet",
    label: "Case Sheet",
  },
];
const ButtonListsinitialSegment = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "vital",
    label: "Vitals",
  },
  {
    value: "cs",
    label: "Case Sheets",
  },
  {
    value: "diagnosis",
    label: "Diagnosis",
  },
  {
    value: "prescription",
    label: "Prescription",
  },
  {
    value: "cf1",
    label: "Case Sheets",
  },
  {
    value: "cf2",
    label: "Follow Up",
  },
  {
    value: "pst",
    label: "PST",
  },
  {
    value: "protective_factor",
    label: "Protective Factor",
  },
  {
    value: "dots",
    label: "DOTS",
  },
  {
    value: "sos",
    label: "SOS",
  },
  {
    value: "confas",
    label: "CONFAS",
  },
  {
    value: "conpsyq",
    label: "CONPSYQ",
  },
  {
    value: "concog",
    label: "Concog",
  },
  {
    value: "tpn",
    label: "Theraphy Progress Note",
  },
  {
    value: "casesheet",
    label: "Case Sheet",
  },
];
const keyArray = ["all", "prescription", "diagnosis", "vital", "casesheet"];
class PatientDetailBannerNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      genAssess: false,
      stressMng: false,
      feedBackRprt: false,
      geriatric: false,
      statusResult: false,
      tabLabel: "all",
      form_action: false,
      // ButtonLists: ButtonListsinitial.filter((item) =>
      //   keyArray.includes(item.key)),
      ButtonLists: ButtonListsinitialSegment.filter((item) =>
        keyArray.includes(item.value)
      ),
    };
  }

  handleButtonActions(col) {
    let value = {
      gender: this.props?.gender || "male",
      patient_id: this.props?.patient_id || "",
      user_type: this.props?.user_type || "adult",
    };
    if (col == "prescription")
      utils.Modal(true, {
        content: <Prescription data={value} />,
        width: "70vw",
      });
    else if (col == "therapy_intake")
      utils.Modal(true, {
        content: <TherapyTab data={value} />,
        width: "850px",
      });
    else if (col == "dsm_screening")
      utils.Modal(true, {
        content: <DSMScreening data={value} />,
        width: "850px",
      });
    else if (col == "mhe")
      utils.Modal(true, { content: <MHE data={value} />, width: "850px" });
    else if (col == "diagnosis")
      utils.Modal(true, {
        content: <DiagnosisNewSummary data={value} />,
        width: "850px",
      });
    else if (col == "cf1")
      utils.Modal(true, {
        content: <DiagnosisSummary data={value} />,
        width: "850px",
      });
    else if (col == "cf2")
      utils.Modal(true, {
        content: <TreatmentSummary data={value} />,
        width: "850px",
      });
    else if (col == "pst")
      utils.Modal(true, {
        content: <PSTSummary data={value} />,
        width: "850px",
      });
    else if (col == "protective_factor")
      utils.Modal(true, {
        content: <ProtectiveFactorSummary data={value} />,
        width: "850px",
      });
    else if (col == "dots")
      utils.Modal(true, {
        content: <DOTSNewSummary data={value} />,
        width: "850px",
      });
    else if (col == "sos")
      utils.Modal(true, {
        content: <SOSSummary data={value} />,
        width: "850px",
      });
    else if (col == "cs")
      utils.Modal(true, {
        content: <UploadDocSummary data={value} />,
        width: "850px",
      });
    else if (col == "confas")
      utils.Modal(true, {
        content: <GeriatricSummary title="CONFAS" data={value} />,
        width: "850px",
      });
    else if (col == "conpsyq")
      utils.Modal(true, {
        content: <GeriatricSummary title="CONPSYQ" data={value} />,
        width: "850px",
      });
    else if (col == "concog")
      utils.Modal(true, {
        content: <ConcogSummary data={value} />,
        width: "850px",
      });
    else if (col == "tpn")
      utils.Modal(true, {
        content: <TheraphyProgressNote data={value} />,
        width: "850px",
      });
    else if (col == "vital")
      utils.Modal(true, {
        content: <VitalFormHistoryDoctor data={value} />,
        width: "70vw",
      });
  }
  componentDidMount() {
    Object.entries(this.props?.status).map((key) => {
      if (
        key[1] === true &&
        key[0] !== "is_phi" &&
        key[0] !== "is_assessment"
      ) {
        this.setState({ statusResult: true });
        return;
      }
    });
  }
  renderContent = (key, data) => {
    let value = {
      gender: this.props?.gender || "male",
      patient_id: this.props?.patient_id || "",
      user_type: this.props?.user_type || "adult",
    };
    let modalContent;
    let modalWidth;

    switch (key) {
      case "all":
        modalContent = <PatientDetailsAll data={value} />;
        modalWidth = "70vw";
        break;
      case "prescription":
        modalContent = <Prescription data={value} from="consultation" />;
        modalWidth = "70vw";
        break;
      case "therapy_intake":
        modalContent = <TherapyTab data={value} />;
        modalWidth = "850px";
        break;
      case "dsm_screening":
        modalContent = <DSMScreening data={value} />;
        modalWidth = "850px";
        break;
      case "mhe":
        modalContent = <MHE data={value} />;
        modalWidth = "850px";
        break;
      case "diagnosis":
        modalContent = <DiagnosisNewSummary data={value} from="consultation" />;
        modalWidth = "850px";
        break;
      case "cf1":
        modalContent = <DiagnosisSummary data={value} />;
        modalWidth = "850px";
        break;
      case "cf2":
        modalContent = <TreatmentSummary data={value} />;
        modalWidth = "850px";
        break;
      case "pst":
        modalContent = <PSTSummary data={value} />;
        modalWidth = "850px";
        break;
      case "protective_factor":
        modalContent = <ProtectiveFactorSummary data={value} />;
        modalWidth = "850px";
        break;
      case "dots":
        modalContent = <DOTSNewSummary data={value} />;
        modalWidth = "850px";
        break;
      case "sos":
        modalContent = <SOSSummary data={value} />;
        modalWidth = "850px";
        break;
      case "cs":
        modalContent = <UploadDocSummary data={value} />;
        modalWidth = "850px";
        break;
      case "confas":
        modalContent = <GeriatricSummary title="CONFAS" data={value} />;
        modalWidth = "850px";
        break;
      case "conpsyq":
        modalContent = <GeriatricSummary title="CONPSYQ" data={value} />;
        modalWidth = "850px";
        break;
      case "concog":
        modalContent = <ConcogSummary data={value} />;
        modalWidth = "850px";
        break;
      case "tpn":
        modalContent = <TheraphyProgressNote data={value} />;
        modalWidth = "850px";
        break;
      case "vital":
        modalContent = (
          <VitalFormHistoryDoctor
            data={value}
            isChartShow={true}
            from="consultation"
          />
        );
        modalWidth = "70vw";
        break;
      case "casesheet":
        modalContent = <Casesheet data={value} from="consultation" />;
        modalWidth = "70vw";
        break;
    }
    return modalContent;
  };
  handleTabSelection = ({ key }) => {
    // this.getConsultationStatus();
    this.setState({
      tabLabel: key,
    });
    // scrollIntoView(document.getElementById(`tab-content`));
  };
  handleTabSelectionSegment = (tab) => {
    // console.log("handleTabSelectionSegment", tab);
    // this.getConsultationStatus();
    this.setState({
      tabLabel: tab,
    });
    // scrollIntoView(document.getElementById(`tab-content`));
  };
  render() {
    return (
      <Row gutter={24} className="patientDetailBannerNew">
        <Col className="gutter-row tab-container" span={24}>
          <></>
          <div className="carousel-content">
            <Layout className="consultation-layout-container">
              {/* <Sider className="sider-video-consultation">
                <Menu
                  mode="inline"
                  selectedKeys={[`${this.state.tabLabel}`]}
                  onSelect={
                    this.state.form_action
                      ? this.unsavedPopup
                      : this.handleTabSelection
                  }
                  items={this.state.ButtonLists}
                />
              </Sider> */}
              <Header className="patientDetailSwitch">
                <Segmented
                  size="large"
                  value={this.state.tabLabel}
                  onChange={this.handleTabSelectionSegment}
                  options={this.state.ButtonLists}
                />
              </Header>
              <Content className="consultation-layout-content">
                <div className="tab-content" id="tab-content">
                  {this.renderContent(this.state.tabLabel)}
                </div>
              </Content>
            </Layout>
          </div>
        </Col>
      </Row>
    );
    // return (
    //   <>
    //     {this.state.statusResult && (
    //       <div className="banner-containers">
    //         <div className="banner-content">
    //           {/* {(this.props.status?.is_dsm || this.props.status?.is_mse || this.props.status?.is_theraphy || this.props.status?.is_tpn) &&
    //                 <div className='button-patient-history'>
    //                 <Popover title={CONSTANTS.GEN_ASSESS}
    //                  open={this.state.genAssess} onOpenChange={e => {this.setState({genAssess:e})}}
    //                   content={<>
    //                  {this.props.status?.is_dsm &&<Tag className='subTags dsm'  onClick={e => {
    //                 this.handleButtonActions("dsm_screening");
    //                 this.setState({genAssess:false});}}>{CONSTANTS.DSM}</Tag>}
    //                 {this.props.status?.is_mse && <Tag className='subTags mse' onClick={e => {this.handleButtonActions("mhe");
    //                  this.setState({genAssess:false});}}>{CONSTANTS.MSE}</Tag>}
    //                 {this.props.status?.is_theraphy &&  <Tag className='subTags psy'
    //                 onClick={e => {this.handleButtonActions("therapy_intake");
    //                 this.setState({genAssess:false});}}>{CONSTANTS.PSY}</Tag>}
    //                 {this.props.status?.is_tpn && <Tag className='subTags tpn'
    //                 onClick={e => {this.handleButtonActions("tpn");
    //                 this.setState({genAssess:false});}}>{CONSTANTS.TPN}</Tag>}
    //                 </>}>
    //                  <Tag className='iconsBanner commonTab'>{CONSTANTS.GEN_ASSESS}</Tag>
    //                 </Popover>
    //              </div>}

    //              {(this.props.status?.is_protective_factor || this.props.status?.is_dot || this.props.status?.is_sos) &&  <div className='button-patient-history'>
    //                   <Popover title={CONSTANTS.STRESS_MNG}  open={this.state.stressMng} onOpenChange={e => {this.setState({stressMng:e})}}
    //                   content={<>
    //                   {this.props.status?.is_protective_factor &&   <Tag className='subTags p-fact'
    //                   onClick={e => {this.handleButtonActions("protective_factor"); this.setState({stressMng:false});}}>{CONSTANTS.PFACT}</Tag>}
    //                   {this.props.status?.is_dot &&   <Tag className='subTags dots'
    //                   onClick={e => {this.handleButtonActions("dots"); this.setState({stressMng:false});}}>{CONSTANTS.DOTS}</Tag>}
    //                   {this.props.status?.is_sos && <Tag className='subTags sos'
    //                   onClick={e => {this.handleButtonActions("sos"); this.setState({stressMng:false});}}>{CONSTANTS.SOS}</Tag>}
    //                   </>}>
    //                    <Tag className='iconsBanner commonTab'>{CONSTANTS.STRESS_MNG}</Tag>
    //                   </Popover>
    //                </div>}
    //                {(this.props.status?.is_case_formulation1 || this.props.status?.is_case_formulation2 || this.props.status?.is_psychiatry_fb) &&
    //                <div className='button-patient-history'>
    //                   <Popover title={CONSTANTS.FEED_RPT} open={this.state.feedBackRprt} onOpenChange={e => {this.setState({feedBackRprt:e})}}
    //                   content={<>
    //                    {this.props.status?.is_case_formulation1 &&<Tag className='subTags diag'
    //                    onClick={e => {this.handleButtonActions("cf1"); this.setState({feedBackRprt:false});}}>{CONSTANTS.CF1}</Tag>}
    //                   {this.props.status?.is_case_formulation2 && <Tag className='subTags t-plan'
    //                    onClick={e => {this.handleButtonActions("cf2"); this.setState({feedBackRprt:false});}}>{CONSTANTS.CF2}</Tag>}
    //                    {this.props.status?.is_psychiatry_fb && <Tag className='subTags pst'
    //                    onClick={e => {this.handleButtonActions("pst"); ; this.setState({feedBackRprt:false});}}>{CONSTANTS.PST}</Tag>}
    //                   </>}>
    //                    <Tag className='iconsBanner commonTab'>{CONSTANTS.FEED_RPT}</Tag>
    //                   </Popover>
    //                </div>} */}

    //           {this.props.status?.is_prescription && (
    //             <div className="button-patient-history">
    //               <Tag
    //                 className="iconsBanner commonTab"
    //                 onClick={(e) => this.handleButtonActions("prescription")}
    //               >
    //                 {CONSTANTS.PRESCRIPTION}
    //               </Tag>
    //             </div>
    //           )}
    //           {this.props.status?.is_diagnosis && (
    //             <div className="button-patient-history">
    //               <Tag
    //                 className="iconsBanner commonTab"
    //                 onClick={(e) => this.handleButtonActions("diagnosis")}
    //               >
    //                 {CONSTANTS.DIAGNOSIS}
    //               </Tag>
    //             </div>
    //           )}
    //           {/* {this.props.status?.is_document_upload &&
    //                 <div className='button-patient-history'>
    //                 <Tag className='iconsBanner commonTab'
    //                        onClick={e => this.handleButtonActions("cs")}>Documents Upload</Tag>  </div>}

    //          {(this.props.status?.is_concog || this.props.status?.is_conpsyg || this.props.status?.is_confas) && <div className='button-patient-history'>
    //                   <Popover title={CONSTANTS.GERIATRIC}  open={this.state.geriatric} onOpenChange={e => {this.setState({geriatric:e})}}
    //                   content={<>
    //                     {this.props.status?.is_concog && <Tag className='subTags p-fact'
    //                   onClick={e => {this.handleButtonActions("concog"); this.setState({geriatric:false});}}>{CONSTANTS.CONCOG}</Tag>}
    //                    {this.props.status?.is_conpsyg &&  <Tag className='subTags dots'
    //                   onClick={e => {this.handleButtonActions("conpsyq"); this.setState({geriatric:false});}}>{CONSTANTS.CONPSYQ}</Tag>}
    //                    {this.props.status?.is_confas &&  <Tag className='subTags sos'
    //                   onClick={e => {this.handleButtonActions("confas"); this.setState({geriatric:false});}}>{CONSTANTS.CONFAS}</Tag>}
    //                   </>}>
    //                    <Tag className='iconsBanner commonTab'>{CONSTANTS.GERIATRIC}</Tag>
    //                   </Popover>
    //                </div>} */}
    //           {this.props.status?.is_medical_document && (
    //             <div className="button-patient-history">
    //               {" "}
    //               <div>
    //                 <Link
    //                   to={{
    //                     pathname: "document-upload",
    //                     patient_id: this?.props?.patient_id || "",
    //                   }}
    //                 >
    //                   <Tag className="iconsBanner commonTab">
    //                     {"Medical Document"}
    //                   </Tag>
    //                 </Link>
    //               </div>
    //             </div>
    //           )}
    //           {this.props.status?.is_vital ||
    //             (true && (
    //               <div className="button-patient-history">
    //                 <Tag
    //                   className="iconsBanner commonTab"
    //                   onClick={(e) => this.handleButtonActions("vital")}
    //                 >
    //                   {"Vital"}
    //                 </Tag>
    //               </div>
    //             ))}
    //         </div>
    //       </div>
    //     )}
    //   </>
    // );
  }
}

const mapStateToProps = (state) => {
  return {
    patient_id: state.patientDetailReducer.patient_detail,
    gender: state.patientDetailReducer.gender,
    user_type: state.patientDetailReducer.usertype,
  };
};
export default connect(mapStateToProps)(PatientDetailBannerNew);
